import { render } from "./PersonalInfoTab.vue?vue&type=template&id=7a966c0c"
import script from "./PersonalInfoTab.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab.vue?vue&type=script&lang=js"

import "./PersonalInfoTab.vue?vue&type=style&index=0&id=7a966c0c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__